import Login from '../components/login/Login';
import Dashboard from '../components/dashboard';
import EditGroup from '../components/group/EditGroup';
import AddGroup from '../components/group/AddGroup';
import AddTenant from '../components/tenants/AddTenant';
import EditTenant from '../components/tenants/EditTenant';
import AddUser from '../components/user/AddUser';
import List from '../components/common/List';
import UserProfile from '../components/user/UserProfile';
import permissionsInfo from './permissionsInfo';
import EditUser from '../components/user/EditUser';
import AddPatient from '../components/patients/AddPatient';
import Operatories from '../components/operatories';
import Doctors from '../components/doctors';
import EditPatient from '../components/patients/EditPatient';
import Treatments from '../components/treatments';
import ProcessesList from '../components/processes/ProcessesList';
import RunningProcesses from '../components/processes/running_processes';
import StartProcess from '../components/processes/StartProcess';
import CallsSheetList from '../components/callsheet/CallsSheetList';
import TaskList from '../components/tasks/tasklist/TaskList';
import EditCallSheet from '../components/callsheet/EditCallSheet';
import SurveysList from '../components/surveys/list';
import AddSurvey from '../components/surveys/add_survey';
import CompleteSurvey from '../components/surveys/complete_survey';
import AlertSettings from '../components/settings/alert_alarm/AlertSettings';
import TargetTaskTimeSettings from '../components/settings/target_task_time/index';
import OperatoriesOverview from '../components/operatories/operatories_overview';
import ProcessDetails from '../components/processes/ProcessDetails';
import UsersList from '../components/user/list';
import TaskViewWrapper from '../components/tasks/task_view/TaskViewWrapper';
import Reports from '../components/reports';
import Improve from '../components/improve';

export const routes = [
  {
    path: '/',
    component: Dashboard,
    isExact: true,
    permissions: permissionsInfo.dashboard.view
  },
  {
    path: '/login',
    component: Login,
    permissions: null
  },
  {
    path: '/:tenantSlug/login',
    component: Login,
    permissions: null
  },
  {
    path: '/profile',
    component: UserProfile,
    permissions: permissionsInfo.users.profile.edit
  },
  {
    path: '/system-configuration/groups/add',
    component: AddGroup,
    permissions: permissionsInfo.groups.create
  },
  {
    path: '/system-configuration/groups/:id',
    component: EditGroup,
    permissions: permissionsInfo.groups.edit
  },
  {
    path: '/system-configuration/groups',
    component: List,
    isExact: true,
    permissions: permissionsInfo.groups.view
  },
  {
    path: '/system-configuration/users/add',
    component: AddUser,
    permissions: permissionsInfo.users.create
  },
  {
    path: '/system-configuration/users',
    component: UsersList,
    isExact: true,
    permissions: permissionsInfo.users.view
  },
  {
    path: '/system-configuration/users/:id',
    component: EditUser,
    permissions: permissionsInfo.users.view
  },
  {
    path: '/system-configuration/tenants',
    component: List,
    isExact: true,
    permissions: permissionsInfo.tenants.view
  },
  {
    path: '/system-configuration/tenants/add',
    component: AddTenant,
    permissions: permissionsInfo.tenants.create
  },
  {
    path: '/system-configuration/tenants/:id',
    component: EditTenant,
    permissions: permissionsInfo.tenants.edit
  },
  {
    path: '/processes',
    component: ProcessesList,
    isExact: true,
    permissions: permissionsInfo.processes.view
  },
  {
    path: '/processes/start',
    component: StartProcess,
    isExact: true,
    permissions: permissionsInfo.processes.start
  },
  {
    path: '/processes/running',
    component: RunningProcesses,
    isExact: true,
    permissions: permissionsInfo.processes.view
  },
  {
    path: '/processes/running/:id',
    component: ProcessDetails,
    isExact: true,
    permissions: permissionsInfo.processes.view
  },
  {
    path: '/patients',
    component: List,
    isExact: true,
    permissions: permissionsInfo.patients.list.view
  },
  {
    path: '/patients/add',
    component: AddPatient,
    isExact: true,
    permissions: permissionsInfo.patients.create
  },
  {
    path: '/patients/:id',
    component: EditPatient,
    permissions: permissionsInfo.patients.view
  },
  {
    path: '/configuration/users',
    component: UsersList,
    isExact: true,
    permissions: permissionsInfo.tenants_config.list.users
  },
  {
    path: '/configuration/users/add',
    component: AddUser,
    isExact: true,
    permissions: permissionsInfo.tenants_config.users.create
  },
  {
    path: '/configuration/users/:id',
    component: EditUser,
    permissions: permissionsInfo.tenants_config.users.view
  },
  {
    path: '/configuration/operatories',
    component: Operatories,
    isExact: true,
    permissions: permissionsInfo.operatories.view
  },
  {
    path: '/configuration/referring-doctors',
    component: Doctors,
    isExact: true,
    permissions: permissionsInfo.doctors.view
  },
  {
    path: '/configuration/treatments',
    component: Treatments,
    isExact: true,
    permissions: permissionsInfo.treatments.view
  },
  {
    path: '/configuration/process-settings/target-task-times',
    component: TargetTaskTimeSettings,
    isExact: true,
    permissions: permissionsInfo.tasks.time.target
  },
  {
    path: '/tasks',
    component: TaskList,
    isExact: true,
    permissions: [
      permissionsInfo.tasks.view,
      permissionsInfo.tasks.group.view,
      permissionsInfo.tasks.personal.view
    ].flat(1)
  },
  {
    path: '/call-sheets',
    component: CallsSheetList,
    isExact: true,
    permissions: permissionsInfo.calls.view
  },
  {
    path: '/call-sheets/:id',
    component: EditCallSheet,
    isExact: true,
    permissions: permissionsInfo.calls.edit
  },
  {
    path: '/surveys',
    component: SurveysList,
    isExact: true,
    permissions: permissionsInfo.surveys.list.view
  },
  {
    path: '/surveys/add',
    component: AddSurvey,
    isExact: true,
    permissions: permissionsInfo.surveys.list.view
  },
  {
    path: '/surveys/:id',
    component: CompleteSurvey,
    isExact: true,
    permissions: permissionsInfo.surveys.view
  },
  {
    path: '/configuration/process-settings/alert',
    component: AlertSettings,
    isExact: true,
    permissions: [
      ...permissionsInfo.settings.process_progress_alert_range.manage,
      ...permissionsInfo.settings.task_progress_alert_range.manage
    ]
  },
  {
    path: '/process/:processId/tasks',
    component: TaskViewWrapper,
    isExact: true,
    permissions: permissionsInfo.tasks.claim
  },
  {
    path: '/operatories',
    component: OperatoriesOverview,
    permissions: permissionsInfo.operatories.overview
  },
  {
    path: '/improve',
    component: Improve,
    isExact: true,
    permissions: null
  },
  {
    path: '/reports/:id',
    component: Reports,
    permissions: null
  }
];
